import buildActionDispatcher from "~/actions/utilities/buildActionDispatcher";

export default async function ensureUserLoaded(context) {
  if (!context.store.state.user?.id) {
    await buildActionDispatcher("loadUserDefaults")(context);
  }
}
